import { Button, Divider, Tooltip, Typography } from 'antd';
import { sanitizeHTML } from '../../utils';
import { convert } from 'html-to-text';
import { EmailDraft } from './index';

export default function DraftEmail({
  emailDraft,
  leadEmail,
}: {
  emailDraft: EmailDraft;
  leadEmail: string;
}) {
  function convertToMailTo(body: string | undefined) {
    return body
      ?.replace(/<p><br><\/p>/g, '%0D%0A')
      .replace(/&amp;/g, '%26')
      .replace(/&/g, '%26')
      .replace(/<p>/g, '%0D%0A')
      .replace(/<\/p>/g, '%0D%0A')
      .replace(/<br>/g, '%0D%0A')
      .replace(/<br\/>/g, '%0D%0A')
      .replace(/<li>/g, '%20<li>')
      .replace(/<ul>/g, '%0D%0A<ul>')
      .replace(/<ol>/g, '%0D%0A<ol>')
      .replace(/<\/li>/g, '%0D%0A</li>')
      .replace('<html><body>', '')
      .replace('</body></html>', '');
  }

  const constructMailToLink = () => {
    const replacedBody = convertToMailTo(emailDraft?.body) ?? '';
    const convertedBody = convert(replacedBody, {
      wordwrap: false,
      selectors: [
        {
          selector: 'ul',
          format: 'unorderedList',
        },
        { selector: 'ol', format: 'orderedList' },
      ],
    }).replace(/\*/g, '• ');
    const cleanedBody = convertedBody.startsWith('%0D%0A')
      ? convertedBody.slice(6)
      : convertedBody;
    return `mailto:${leadEmail}?subject=${emailDraft?.subject}&body=${cleanedBody}`;
  };

  return (
    <div className="tab-content">
      {window.innerWidth > 768 && (
        <div>
          <Divider />
          <h3>Email draft</h3>
        </div>
      )}
      <Typography.Text
        style={{
          fontWeight: 'bold',
          fontSize: '16px',
          marginBottom: '40px',
        }}
      >
        {emailDraft.subject}
      </Typography.Text>
      <div
        className="tab-content"
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(emailDraft.body || ''),
        }}
        style={{ paddingBottom: '50px' }}
      />
      <div style={{ position: 'absolute', bottom: '20px', right: '20px' }}>
        <a href={constructMailToLink()} rel="noreferrer" target="_blank">
          <Tooltip
            placement="right"
            title="Launches your email app with this message ready to send."
          >
            <Button type="primary">Open Email Draft</Button>
          </Tooltip>
        </a>
      </div>
    </div>
  );
}
